var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tip-box',{attrs:{"text":_vm.$t('module_adgroup_budget_lower_hint'),"type":"warning"}})}
var staticRenderFns = []

export { render, staticRenderFns }